(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _lazysizes = _interopRequireDefault(require("lazysizes"));

require("lazysizes/plugins/native-loading/ls.native-loading");

var _baguettebox = _interopRequireDefault(require("./moduls/baguettebox.js"));

var _pxEasyExpand = _interopRequireDefault(require("./moduls/pxEasyExpand.js"));

var _pxResponsiveBackgroundImage = _interopRequireDefault(require("./moduls/pxResponsiveBackgroundImage.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *
 * Elim Schönheide - JS: JS Base
 *
 * @author Felix Wendler | pixelbrand.net
 * @date   2020-08
 *
 */
// ------------------------------------------
// no-js - falls modernizr deaktiviert wird
document.documentElement.className = document.documentElement.className.replace('no-js', 'js'); // ------------------------------------------
// sticky hover fix für iOS 

(function (l) {
  var i,
      s = {
    touchend: function touchend() {}
  };

  for (i in s) {
    l.addEventListener(i, s);
  }
})(document); // ------------------------------------------
// Dom ready
// use: ready(function() { alert('hello'); });


window.ready = function (fn) {
  if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}; // ------------------------------------------
// jQuery
// import $ from './jquery/jquery-3.4.1.js';
// window.$ = window.jQuery = global.jQuery = $;
// modifiziert, um lauffähig zu sein
// require('./jquery/plugins/jquery.magnific-popup.js'); // https://github.com/texelate/magnificPopupGulpBrowserify
// require('./jquery/plugins/jquery.matchHeight.js'); // https://github.com/baerkins/jquery-match-height-browserify/blob/master/jquery.matchHeight.js
// ------------------------------------------
// Polyfills
// assign


require('./polyfills/assign.js'); // findIndex


require('./polyfills/findindex.js'); // details/summary


ready(function () {
  require('./polyfills/details.js');
}); // ------------------------------------------
// Lazyloading ( npm install lazysizes --save )

_lazysizes.default.cfg.nativeLoading = {
  setLoadingAttribute: true,
  disableListeners: {
    scroll: true
  }
};
_lazysizes.default.cfg.lazyClass = 'js-load';
_lazysizes.default.cfg.loadingClass = 'js-loading';
_lazysizes.default.cfg.loadedClass = 'js-loaded';
_lazysizes.default.cfg.autosizesClass = 'js-autosizes'; // ------------------------------------------
// Libraries
// require('./modernizr/modernizr.js');
// require('./scripts/tabs.js');
// Klassen
// window.A11yDialog = require('./scripts/a11y-dialog.js');
// ------------------------------------------
// Partials
// Toplink

require('./partials/toplink.js'); // Modalfenster
// require('./partials/A11yDialog.js');
// Tabellen
// require('./partials/table-touchscroll.js');
// Accordion
// ready(function() {
//   require('./scripts/aria-accordion.js');
// });
// ------------------------------------------
// Lightbox


ready(function () {
  var lightbox = _baguettebox.default.run('.tm-images', {
    animation: 'fadeIn',
    filter: /.+\.(gif|jpe?g|png|webp)/i,
    overlayBackgroundColor: ''
  });

  if (lightbox.length > 0) {
    document.getElementById('close-button').setAttribute('aria-label', window.lightbox.close);
    document.getElementById('previous-button').setAttribute('aria-label', window.lightbox.prev);
    document.getElementById('next-button').setAttribute('aria-label', window.lightbox.next);
    document.getElementById('previous-button').addEventListener('keydown', function (event) {
      if (event.shiftKey && event.keyCode == 9) {
        event.preventDefault();
        document.getElementById('close-button').focus();
      }
    });
  } // ToDo: a[data-group^="zoom"]

}); // ------------------------------------------
// Hamburger und Mobilnavigation

ready(function () {
  var hamburger = new _pxEasyExpand.default('#hamburger', {
    'closeWithEsc': true,
    'setRootClass': 'navigation-open',
    'keepFocusInTargetElement': true
  });
}); // ------------------------------------------
// responsive Hintergrund-Bilder

ready(function () {
  var responsiveBackground = new _pxResponsiveBackgroundImage.default(document.querySelectorAll('[data-responsive-background-image]'));
}); // ------------------------------------------
// Aufgaben aufgrund bestimmter Fensterbreiten
// import pxBreakpointTasks from './moduls/pxBreakpointTasks.js';
// 
// // var breakpointCallback = function(status) {
// //   console.log(status);
// // }
// 
// ready(function() {
// 
//   const breakpointTasks = new pxBreakpointTasks();
// 
//   // breakpointTasks.addTask('500','800',breakpointCallback);
// 
// });

},{"./moduls/baguettebox.js":2,"./moduls/pxEasyExpand.js":3,"./moduls/pxResponsiveBackgroundImage.js":4,"./partials/toplink.js":5,"./polyfills/assign.js":6,"./polyfills/details.js":7,"./polyfills/findindex.js":8,"lazysizes":9,"lazysizes/plugins/native-loading/ls.native-loading":10}],2:[function(require,module,exports){
"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * baguetteBox.js
 * @author  feimosi
 * @version 1.11.0
 * @url https://github.com/feimosi/baguetteBox.js
 */

/* global define, module */
(function (root, factory) {
  'use strict';

  if (typeof define === 'function' && define.amd) {
    define(factory);
  } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    module.exports = factory();
  } else {
    root.baguetteBox = factory();
  }
})(void 0, function () {
  'use strict'; // SVG shapes used on the buttons

  var leftArrow = '<svg xmlns="http://www.w3.org/2000/svg" role="img" focusable="false" aria-hidden="true" width="28" height="28"><polyline id="previus" points="20,25 9,14 20,3 "/></svg>',
      rightArrow = '<svg xmlns="http://www.w3.org/2000/svg" role="img" focusable="false" aria-hidden="true" width="28" height="28"><polyline id="next" points="8,3 19,14 8,25 "/></svg>',
      closeX = '<svg xmlns="http://www.w3.org/2000/svg" role="img" focusable="false" aria-hidden="true" width="28" height="28"><g id="close"><line x1="3" y1="3" x2="25" y2="25"/><line x1="3" y1="25" x2="25" y2="3"/></g></svg>'; // Global options and their defaults

  var options = {},
      defaults = {
    captions: true,
    buttons: 'auto',
    fullScreen: false,
    noScrollbars: false,
    bodyClass: 'baguetteBox-open',
    titleTag: false,
    async: false,
    preload: 2,
    animation: 'slideIn',
    afterShow: null,
    afterHide: null,
    onChange: null,
    overlayBackgroundColor: 'rgba(0,0,0,.8)'
  }; // Object containing information about features compatibility

  var supports = {}; // DOM Elements references

  var overlay, slider, previousButton, nextButton, closeButton; // An array with all images in the current gallery

  var currentGallery = []; // Current image index inside the slider

  var currentIndex = 0; // Visibility of the overlay

  var isOverlayVisible = false; // Touch event start position (for slide gesture)

  var touch = {}; // If set to true ignore touch events because animation was already fired

  var touchFlag = false; // Regex pattern to match image files

  var regex = /.+\.(gif|jpe?g|png|webp)/i; // Object of all used galleries

  var data = {}; // Array containing temporary images DOM elements

  var imagesElements = []; // The last focused element before opening the overlay

  var documentLastFocus = null;

  var overlayClickHandler = function overlayClickHandler(event) {
    // Close the overlay when user clicks directly on the background
    if (event.target.id.indexOf('baguette-img') !== -1) {
      hideOverlay();
    }
  };

  var previousButtonClickHandler = function previousButtonClickHandler(event) {
    event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true; // eslint-disable-line no-unused-expressions

    showPreviousImage();
  };

  var nextButtonClickHandler = function nextButtonClickHandler(event) {
    event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true; // eslint-disable-line no-unused-expressions

    showNextImage();
  };

  var closeButtonClickHandler = function closeButtonClickHandler(event) {
    event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true; // eslint-disable-line no-unused-expressions

    hideOverlay();
  };

  var touchstartHandler = function touchstartHandler(event) {
    touch.count++;

    if (touch.count > 1) {
      touch.multitouch = true;
    } // Save x and y axis position


    touch.startX = event.changedTouches[0].pageX;
    touch.startY = event.changedTouches[0].pageY;
  };

  var touchmoveHandler = function touchmoveHandler(event) {
    // If action was already triggered or multitouch return
    if (touchFlag || touch.multitouch) {
      return;
    }

    event.preventDefault ? event.preventDefault() : event.returnValue = false; // eslint-disable-line no-unused-expressions

    var touchEvent = event.touches[0] || event.changedTouches[0]; // Move at least 40 pixels to trigger the action

    if (touchEvent.pageX - touch.startX > 40) {
      touchFlag = true;
      showPreviousImage();
    } else if (touchEvent.pageX - touch.startX < -40) {
      touchFlag = true;
      showNextImage(); // Move 100 pixels up to close the overlay
    } else if (touch.startY - touchEvent.pageY > 100) {
      hideOverlay();
    }
  };

  var touchendHandler = function touchendHandler() {
    touch.count--;

    if (touch.count <= 0) {
      touch.multitouch = false;
    }

    touchFlag = false;
  };

  var contextmenuHandler = function contextmenuHandler() {
    touchendHandler();
  };

  var trapFocusInsideOverlay = function trapFocusInsideOverlay(event) {
    if (overlay.style.display === 'block' && overlay.contains && !overlay.contains(event.target)) {
      event.stopPropagation();
      initFocus();
    }
  }; // forEach polyfill for IE8
  // http://stackoverflow.com/a/14827443/1077846

  /* eslint-disable */


  if (![].forEach) {
    Array.prototype.forEach = function (callback, thisArg) {
      for (var i = 0; i < this.length; i++) {
        callback.call(thisArg, this[i], i, this);
      }
    };
  } // filter polyfill for IE8
  // https://gist.github.com/eliperelman/1031656


  if (![].filter) {
    Array.prototype.filter = function (a, b, c, d, e) {
      c = this;
      d = [];

      for (e = 0; e < c.length; e++) {
        a.call(b, c[e], e, c) && d.push(c[e]);
      }

      return d;
    };
  }
  /* eslint-enable */
  // Script entry point


  function run(selector, userOptions) {
    // Fill supports object
    supports.transforms = testTransformsSupport();
    supports.svg = testSvgSupport();
    supports.passiveEvents = testPassiveEventsSupport();
    buildOverlay();
    removeFromCache(selector);
    return bindImageClickListeners(selector, userOptions);
  }

  function bindImageClickListeners(selector, userOptions) {
    // For each gallery bind a click event to every image inside it
    var galleryNodeList = document.querySelectorAll(selector);
    var selectorData = {
      galleries: [],
      nodeList: galleryNodeList
    };
    data[selector] = selectorData;
    [].forEach.call(galleryNodeList, function (galleryElement) {
      if (userOptions && userOptions.filter) {
        regex = userOptions.filter;
      } // Get nodes from gallery elements or single-element galleries


      var tagsNodeList = [];

      if (galleryElement.tagName === 'A') {
        tagsNodeList = [galleryElement];
      } else {
        tagsNodeList = galleryElement.getElementsByTagName('a');
      } // Filter 'a' elements from those not linking to images


      tagsNodeList = [].filter.call(tagsNodeList, function (element) {
        if (element.className.indexOf(userOptions && userOptions.ignoreClass) === -1) {
          return regex.test(element.href);
        }
      });

      if (tagsNodeList.length === 0) {
        return;
      }

      var gallery = [];
      [].forEach.call(tagsNodeList, function (imageElement, imageIndex) {
        var imageElementClickHandler = function imageElementClickHandler(event) {
          event.preventDefault ? event.preventDefault() : event.returnValue = false; // eslint-disable-line no-unused-expressions

          prepareOverlay(gallery, userOptions);
          showOverlay(imageIndex);
        };

        var imageItem = {
          eventHandler: imageElementClickHandler,
          imageElement: imageElement
        };
        bind(imageElement, 'click', imageElementClickHandler);
        gallery.push(imageItem);
      });
      selectorData.galleries.push(gallery);
    });
    return selectorData.galleries;
  }

  function clearCachedData() {
    for (var selector in data) {
      if (data.hasOwnProperty(selector)) {
        removeFromCache(selector);
      }
    }
  }

  function removeFromCache(selector) {
    if (!data.hasOwnProperty(selector)) {
      return;
    }

    var galleries = data[selector].galleries;
    [].forEach.call(galleries, function (gallery) {
      [].forEach.call(gallery, function (imageItem) {
        unbind(imageItem.imageElement, 'click', imageItem.eventHandler);
      });

      if (currentGallery === gallery) {
        currentGallery = [];
      }
    });
    delete data[selector];
  }

  function buildOverlay() {
    overlay = getByID('baguetteBox-overlay'); // Check if the overlay already exists

    if (overlay) {
      slider = getByID('baguetteBox-slider');
      previousButton = getByID('previous-button');
      nextButton = getByID('next-button');
      closeButton = getByID('close-button');
      return;
    } // Create overlay element


    overlay = create('div');
    overlay.setAttribute('role', 'dialog');
    overlay.id = 'baguetteBox-overlay';
    document.getElementsByTagName('body')[0].appendChild(overlay); // Create gallery slider element

    slider = create('div');
    slider.id = 'baguetteBox-slider';
    overlay.appendChild(slider); // Create all necessary buttons

    previousButton = create('button');
    previousButton.setAttribute('type', 'button');
    previousButton.id = 'previous-button';
    previousButton.setAttribute('aria-label', 'Previous');
    previousButton.innerHTML = supports.svg ? leftArrow : '&lt;';
    overlay.appendChild(previousButton);
    nextButton = create('button');
    nextButton.setAttribute('type', 'button');
    nextButton.id = 'next-button';
    nextButton.setAttribute('aria-label', 'Next');
    nextButton.innerHTML = supports.svg ? rightArrow : '&gt;';
    overlay.appendChild(nextButton);
    closeButton = create('button');
    closeButton.setAttribute('type', 'button');
    closeButton.id = 'close-button';
    closeButton.setAttribute('aria-label', 'Close');
    closeButton.innerHTML = supports.svg ? closeX : '&times;';
    overlay.appendChild(closeButton);
    previousButton.className = nextButton.className = closeButton.className = 'baguetteBox-button';
    bindEvents();
  }

  function keyDownHandler(event) {
    switch (event.keyCode) {
      case 37:
        // Left arrow
        showPreviousImage();
        break;

      case 39:
        // Right arrow
        showNextImage();
        break;

      case 27:
        // Esc
        hideOverlay();
        break;

      case 36:
        // Home
        showFirstImage(event);
        break;

      case 35:
        // End
        showLastImage(event);
        break;
    }
  }

  function bindEvents() {
    var options = supports.passiveEvents ? {
      passive: true
    } : null;
    bind(overlay, 'click', overlayClickHandler);
    bind(previousButton, 'click', previousButtonClickHandler);
    bind(nextButton, 'click', nextButtonClickHandler);
    bind(closeButton, 'click', closeButtonClickHandler);
    bind(slider, 'contextmenu', contextmenuHandler);
    bind(overlay, 'touchstart', touchstartHandler, options);
    bind(overlay, 'touchmove', touchmoveHandler, options);
    bind(overlay, 'touchend', touchendHandler);
    bind(document, 'focus', trapFocusInsideOverlay, true);
  }

  function unbindEvents() {
    var options = supports.passiveEvents ? {
      passive: true
    } : null;
    unbind(overlay, 'click', overlayClickHandler);
    unbind(previousButton, 'click', previousButtonClickHandler);
    unbind(nextButton, 'click', nextButtonClickHandler);
    unbind(closeButton, 'click', closeButtonClickHandler);
    unbind(slider, 'contextmenu', contextmenuHandler);
    unbind(overlay, 'touchstart', touchstartHandler, options);
    unbind(overlay, 'touchmove', touchmoveHandler, options);
    unbind(overlay, 'touchend', touchendHandler);
    unbind(document, 'focus', trapFocusInsideOverlay, true);
  }

  function prepareOverlay(gallery, userOptions) {
    // If the same gallery is being opened prevent from loading it once again
    if (currentGallery === gallery) {
      return;
    }

    currentGallery = gallery; // Update gallery specific options

    setOptions(userOptions); // Empty slider of previous contents (more effective than .innerHTML = "")

    while (slider.firstChild) {
      slider.removeChild(slider.firstChild);
    }

    imagesElements.length = 0;
    var imagesFiguresIds = [];
    var imagesCaptionsIds = []; // Prepare and append images containers and populate figure and captions IDs arrays

    for (var i = 0, fullImage; i < gallery.length; i++) {
      fullImage = create('div');
      fullImage.className = 'full-image';
      fullImage.id = 'baguette-img-' + i;
      imagesElements.push(fullImage);
      imagesFiguresIds.push('baguetteBox-figure-' + i);
      imagesCaptionsIds.push('baguetteBox-figcaption-' + i);
      slider.appendChild(imagesElements[i]);
    }

    overlay.setAttribute('aria-labelledby', imagesFiguresIds.join(' '));
    overlay.setAttribute('aria-describedby', imagesCaptionsIds.join(' '));
  }

  function setOptions(newOptions) {
    if (!newOptions) {
      newOptions = {};
    } // Fill options object


    for (var item in defaults) {
      options[item] = defaults[item];

      if (typeof newOptions[item] !== 'undefined') {
        options[item] = newOptions[item];
      }
    }
    /* Apply new options */
    // Change transition for proper animation


    slider.style.transition = slider.style.webkitTransition = options.animation === 'fadeIn' ? 'opacity .4s ease' : options.animation === 'slideIn' ? '' : 'none'; // Hide buttons if necessary

    if (options.buttons === 'auto' && ('ontouchstart' in window || currentGallery.length === 1)) {
      options.buttons = false;
    } // Set buttons style to hide or display them


    previousButton.style.display = nextButton.style.display = options.buttons ? '' : 'none'; // Set overlay color

    try {
      overlay.style.backgroundColor = options.overlayBackgroundColor;
    } catch (e) {// Silence the error and continue
    }
  }

  function showOverlay(chosenImageIndex) {
    if (options.noScrollbars) {
      document.documentElement.style.overflowY = 'hidden';
      document.body.style.overflowY = 'scroll';
    }

    if (overlay.style.display === 'block') {
      return;
    }

    bind(document, 'keydown', keyDownHandler);
    currentIndex = chosenImageIndex;
    touch = {
      count: 0,
      startX: null,
      startY: null
    };
    loadImage(currentIndex, function () {
      preloadNext(currentIndex);
      preloadPrev(currentIndex);
    });
    updateOffset();
    overlay.style.display = 'block';

    if (options.fullScreen) {
      enterFullScreen();
    } // Fade in overlay


    setTimeout(function () {
      overlay.className = 'visible';

      if (options.bodyClass && document.body.classList) {
        document.body.classList.add(options.bodyClass);
      }

      if (options.afterShow) {
        options.afterShow();
      }
    }, 50);

    if (options.onChange) {
      options.onChange(currentIndex, imagesElements.length);
    }

    documentLastFocus = document.activeElement;
    initFocus();
    isOverlayVisible = true;
  }

  function initFocus() {
    if (options.buttons) {
      previousButton.focus();
    } else {
      closeButton.focus();
    }
  }

  function enterFullScreen() {
    if (overlay.requestFullscreen) {
      overlay.requestFullscreen();
    } else if (overlay.webkitRequestFullscreen) {
      overlay.webkitRequestFullscreen();
    } else if (overlay.mozRequestFullScreen) {
      overlay.mozRequestFullScreen();
    }
  }

  function exitFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    }
  }

  function hideOverlay() {
    if (options.noScrollbars) {
      document.documentElement.style.overflowY = 'auto';
      document.body.style.overflowY = 'auto';
    }

    if (overlay.style.display === 'none') {
      return;
    }

    unbind(document, 'keydown', keyDownHandler); // Fade out and hide the overlay

    overlay.className = '';
    setTimeout(function () {
      overlay.style.display = 'none';

      if (document.fullscreen) {
        exitFullscreen();
      }

      if (options.bodyClass && document.body.classList) {
        document.body.classList.remove(options.bodyClass);
      }

      if (options.afterHide) {
        options.afterHide();
      }

      documentLastFocus && documentLastFocus.focus();
      isOverlayVisible = false;
    }, 500);
  }

  function loadImage(index, callback) {
    var imageContainer = imagesElements[index];
    var galleryItem = currentGallery[index]; // Return if the index exceeds prepared images in the overlay
    // or if the current gallery has been changed / closed

    if (typeof imageContainer === 'undefined' || typeof galleryItem === 'undefined') {
      return;
    } // If image is already loaded run callback and return


    if (imageContainer.getElementsByTagName('img')[0]) {
      if (callback) {
        callback();
      }

      return;
    } // Get element reference, optional caption and source path


    var imageElement = galleryItem.imageElement;
    var thumbnailElement = imageElement.getElementsByTagName('img')[0];
    var imageCaption = typeof options.captions === 'function' ? options.captions.call(currentGallery, imageElement) : imageElement.getAttribute('data-caption') || imageElement.title;
    var imageSrc = getImageSrc(imageElement); // Prepare figure element

    var figure = create('figure');
    figure.id = 'baguetteBox-figure-' + index;
    figure.innerHTML = '<div class="baguetteBox-spinner">' + '<div class="baguetteBox-double-bounce1"></div>' + '<div class="baguetteBox-double-bounce2"></div>' + '</div>'; // Insert caption if available

    if (options.captions && imageCaption) {
      var figcaption = create('figcaption');
      figcaption.id = 'baguetteBox-figcaption-' + index;
      figcaption.innerHTML = imageCaption;
      figure.appendChild(figcaption);
    }

    imageContainer.appendChild(figure); // Prepare gallery img element

    var image = create('img');

    image.onload = function () {
      // Remove loader element
      var spinner = document.querySelector('#baguette-img-' + index + ' .baguetteBox-spinner');
      figure.removeChild(spinner);

      if (!options.async && callback) {
        callback();
      }
    };

    image.setAttribute('src', imageSrc);
    image.alt = thumbnailElement ? thumbnailElement.alt || '' : '';

    if (options.titleTag && imageCaption) {
      image.title = imageCaption;
    }

    figure.appendChild(image); // Run callback

    if (options.async && callback) {
      callback();
    }
  } // Get image source location, mostly used for responsive images


  function getImageSrc(image) {
    // Set default image path from href
    var result = image.href; // If dataset is supported find the most suitable image

    if (image.dataset) {
      var srcs = []; // Get all possible image versions depending on the resolution

      for (var item in image.dataset) {
        if (item.substring(0, 3) === 'at-' && !isNaN(item.substring(3))) {
          srcs[item.replace('at-', '')] = image.dataset[item];
        }
      } // Sort resolutions ascending


      var keys = Object.keys(srcs).sort(function (a, b) {
        return parseInt(a, 10) < parseInt(b, 10) ? -1 : 1;
      }); // Get real screen resolution

      var width = window.innerWidth * window.devicePixelRatio; // Find the first image bigger than or equal to the current width

      var i = 0;

      while (i < keys.length - 1 && keys[i] < width) {
        i++;
      }

      result = srcs[keys[i]] || result;
    }

    return result;
  } // Return false at the right end of the gallery


  function showNextImage() {
    return show(currentIndex + 1);
  } // Return false at the left end of the gallery


  function showPreviousImage() {
    return show(currentIndex - 1);
  } // Return false at the left end of the gallery


  function showFirstImage(event) {
    if (event) {
      event.preventDefault();
    }

    return show(0);
  } // Return false at the right end of the gallery


  function showLastImage(event) {
    if (event) {
      event.preventDefault();
    }

    return show(currentGallery.length - 1);
  }
  /**
   * Move the gallery to a specific index
   * @param `index` {number} - the position of the image
   * @param `gallery` {array} - gallery which should be opened, if omitted assumes the currently opened one
   * @return {boolean} - true on success or false if the index is invalid
   */


  function show(index, gallery) {
    if (!isOverlayVisible && index >= 0 && index < gallery.length) {
      prepareOverlay(gallery, options);
      showOverlay(index);
      return true;
    }

    if (index < 0) {
      if (options.animation) {
        bounceAnimation('left');
      }

      return false;
    }

    if (index >= imagesElements.length) {
      if (options.animation) {
        bounceAnimation('right');
      }

      return false;
    }

    currentIndex = index;
    loadImage(currentIndex, function () {
      preloadNext(currentIndex);
      preloadPrev(currentIndex);
    });
    updateOffset();

    if (options.onChange) {
      options.onChange(currentIndex, imagesElements.length);
    }

    return true;
  }
  /**
   * Triggers the bounce animation
   * @param {('left'|'right')} direction - Direction of the movement
   */


  function bounceAnimation(direction) {
    slider.className = 'bounce-from-' + direction;
    setTimeout(function () {
      slider.className = '';
    }, 400);
  }

  function updateOffset() {
    var offset = -currentIndex * 100 + '%';

    if (options.animation === 'fadeIn') {
      slider.style.opacity = 0;
      setTimeout(function () {
        supports.transforms ? slider.style.transform = slider.style.webkitTransform = 'translate3d(' + offset + ',0,0)' : slider.style.left = offset;
        slider.style.opacity = 1;
      }, 400);
    } else {
      supports.transforms ? slider.style.transform = slider.style.webkitTransform = 'translate3d(' + offset + ',0,0)' : slider.style.left = offset;
    }
  } // CSS 3D Transforms test


  function testTransformsSupport() {
    var div = create('div');
    return typeof div.style.perspective !== 'undefined' || typeof div.style.webkitPerspective !== 'undefined';
  } // Inline SVG test


  function testSvgSupport() {
    var div = create('div');
    div.innerHTML = '<svg/>';
    return (div.firstChild && div.firstChild.namespaceURI) === 'http://www.w3.org/2000/svg';
  } // Borrowed from https://github.com/seiyria/bootstrap-slider/pull/680/files

  /* eslint-disable getter-return */


  function testPassiveEventsSupport() {
    var passiveEvents = false;

    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function get() {
          passiveEvents = true;
        }
      });
      window.addEventListener('test', null, opts);
    } catch (e) {
      /* Silence the error and continue */
    }

    return passiveEvents;
  }
  /* eslint-enable getter-return */


  function preloadNext(index) {
    if (index - currentIndex >= options.preload) {
      return;
    }

    loadImage(index + 1, function () {
      preloadNext(index + 1);
    });
  }

  function preloadPrev(index) {
    if (currentIndex - index >= options.preload) {
      return;
    }

    loadImage(index - 1, function () {
      preloadPrev(index - 1);
    });
  }

  function bind(element, event, callback, options) {
    if (element.addEventListener) {
      element.addEventListener(event, callback, options);
    } else {
      // IE8 fallback
      element.attachEvent('on' + event, function (event) {
        // `event` and `event.target` are not provided in IE8
        event = event || window.event;
        event.target = event.target || event.srcElement;
        callback(event);
      });
    }
  }

  function unbind(element, event, callback, options) {
    if (element.removeEventListener) {
      element.removeEventListener(event, callback, options);
    } else {
      // IE8 fallback
      element.detachEvent('on' + event, callback);
    }
  }

  function getByID(id) {
    return document.getElementById(id);
  }

  function create(element) {
    return document.createElement(element);
  }

  function destroyPlugin() {
    unbindEvents();
    clearCachedData();
    unbind(document, 'keydown', keyDownHandler);
    document.getElementsByTagName('body')[0].removeChild(document.getElementById('baguetteBox-overlay'));
    data = {};
    currentGallery = [];
    currentIndex = 0;
  }

  return {
    run: run,
    show: show,
    showNext: showNextImage,
    showPrevious: showPreviousImage,
    hide: hideOverlay,
    destroy: destroyPlugin
  };
});

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var pxEasyExpand =
/*#__PURE__*/
function () {
  function pxEasyExpand(buttonID) {
    var _this = this;

    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, pxEasyExpand);

    this.defaults = {
      'setRootClass': false,
      // soll eine Klasse im HTML gesetzt werden
      'switchButtonHtml': false,
      'addCloseButton': false,
      'closeWithEsc': false,
      'setFocusToElement': false,
      // Selector oder false
      'setFocusToFirstElement': false,
      'keepFocusInTargetElement': false,
      'disableFocusHandling': false,
      'resetScrollPosition': false // verwendet aktuell noch jQuery

    }; // Config erstellen

    this.config = Object.assign(this.defaults, settings); // ID des Button

    this.buttonObj = document.getElementById(buttonID.replace('#', '')); // der ein/auszublendender wird gespeichert Container

    this.targetObj = [];

    if (this.buttonObj && this.buttonObj.hasAttribute('data-controls')) {
      var targetIds = this.buttonObj.getAttribute('data-controls').split(' ');

      for (var i = 0; i < targetIds.length; i++) {
        this.targetObj[i] = document.getElementById(targetIds[i]);
      }
    } else if (this.buttonObj && this.buttonObj.hasAttribute('href')) {
      this.targetObj[0] = document.getElementById(this.buttonObj.hash.replace('#', ''));
    } // Abbruch falls es keinen Ziel-Container gibt


    if (this.targetObj.length < 1) {
      return;
    } // Aria-Labels des Buttons


    this.labelOpen = this.buttonObj.getAttribute('data-label-open');
    this.labelClose = this.buttonObj.getAttribute('data-label-close'); // Text des Buttons

    this.textOpen = this.buttonObj.hasAttribute('data-text-open') ? this.buttonObj.getAttribute('data-text-open') : this.labelOpen;
    this.textClose = this.buttonObj.hasAttribute('data-text-close') ? this.buttonObj.getAttribute('data-text-close') : this.labelClose; // Text des Focus Helpers

    this.focusHelperText = this.buttonObj.getAttribute('data-focus-helper-text'); // auf gehts

    if (this.buttonObj) {
      // Aria-Attribute einfügen
      this.addAria(); // Button belegen und Funktion anbinden

      this.buttonObj.addEventListener('click', function (event) {
        event.preventDefault();

        _this.toggleStates();
      }, false); // Schließen-Button einfügen

      if (this.config.addCloseButton !== false) {
        this.closeButtonObj = document.createElement('button');
        this.closeButtonObj.innerHTML = '<span>' + this.textClose + '</span>';
        this.setAttributes(this.closeButtonObj, {
          'aria-controls': this.targetObj[0].id,
          'aria-expanded': 'true',
          'aria-label': this.labelClose,
          'class': 'js-close'
        });
        this.closeButtonObj.addEventListener('click', function (event) {
          event.preventDefault();

          _this.toggleStates();
        }, false);
        this.targetObj[0].appendChild(this.closeButtonObj);
      } // Schließen mit ESC


      if (this.config.closeWithEsc === true) {
        this.targetObj[0].addEventListener('keyup', function (event) {
          if (event.defaultPrevented) {
            return;
          }

          var key = event.key || event.keyCode;

          if (key === 'Escape' || key === 'Esc' || key === 27) {
            event.preventDefault();

            _this.toggleStates();
          }
        });
      } // Tastatursteuerung / Tabreihenfolge: nach dem Steuerungsbutton direkt in das Fenster springen
      // soll nur bei TAB greifen -> (event.which || event.keyCode) == 9


      this.buttonObj.addEventListener('keydown', function (event) {
        if (_this.buttonObj.getAttribute('aria-expanded') === 'true' && (event.which || event.keyCode) == 9 && _this.config.keepFocusInTargetElement === true) {
          // Abbruch falls das Focus Handling deaktiviert wurde
          if (_this.config.disableFocusHandling === true) {
            return;
          }

          event.preventDefault(); // kleine Schwachstelle: theoretisch könnten auch andere Elemente Focus erhalten

          var focusableElements = _this.targetObj[0].querySelectorAll('a:not(.focus-helper),input,button');

          if (event.shiftKey === false && focusableElements.length > 0) {
            focusableElements[0].focus();
          } else if (event.shiftKey === true && focusableElements.length > 0) {
            focusableElements[focusableElements.length - 1].focus();
          }
        }
      }); // Tastatursteuerung / Tabreihenfolge

      if (this.config.keepFocusInTargetElement === true) {
        // 1. beim Rückwärtsverlassen des ersten Elements, wird der Focus zurück
        // auf den Öffnen-Button geschoben
        // oder auf den Schließen-Button, falls dieser vorhanden ist
        this.targetObj[0].addEventListener('keydown', function (event) {
          // Abbruch falls das Focus Handling deaktiviert wurde
          if (_this.config.disableFocusHandling === true) {
            return;
          }

          if (event.shiftKey === true && (event.which || event.keyCode) == 9) {
            // kleine Schwachstelle: theoretisch könnten auch andere Elemente Focus erhalten
            if (_this.targetObj[0].querySelector('a,input,button') == event.target) {
              event.preventDefault();

              if (_this.config.addCloseButton === true) {
                _this.closeButtonObj.focus();
              } else {
                _this.buttonObj.focus();
              }
            }
          }
        }); // 2. beim Erreichen eines hier eingefügten Hilfslinks am Ende des Containers,
        // wird ebenfalls der Focus zurück auf den Öffnen-Button geschoben

        var focusHelper = document.createElement('a');
        this.setAttributes(focusHelper, {
          'aria-label': this.focusHelperText,
          'href': '#' + this.buttonObj.id,
          'class': 'focus-helper'
        });
        focusHelper.innerHTML = '<span aria-hidden="true">' + this.focusHelperText + '</span>';
        focusHelper.addEventListener('focus', function (event) {
          event.preventDefault();

          if (_this.config.addCloseButton === true) {
            // kleine Schwachstelle: theoretisch könnten auch andere Elemente Focus erhalten
            var element = _this.targetObj[0].querySelector('a,input,button');

            if (element !== null) {
              element.focus();
            }
          } else {
            _this.buttonObj.focus();
          }
        });
        this.targetObj[0].appendChild(focusHelper);
      }
    }
  }

  _createClass(pxEasyExpand, [{
    key: "setAttributes",
    value: function setAttributes(element, attributes) {
      Object.keys(attributes).forEach(function (key) {
        return element.setAttribute(key, attributes[key]);
      });
    }
  }, {
    key: "toggleStates",
    value: function toggleStates() {
      var _this2 = this;

      var expanded = false;

      if (this.buttonObj.getAttribute('aria-expanded') === 'true') {
        expanded = true;
      } // Scrollt die Seite nach dem Schließen zurück zur Position vor dem Öffnen


      if (this.config.resetScrollPosition !== false) {
        if (expanded === false) {
          this.scrollPosition = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
        } else {
          // muss ausgeführt werden, bevor der Button Focus bekommt
          this.resetScrollPosition();
        }
      }

      window.requestAnimationFrame(function () {
        if (_this2.config.setRootClass !== false) {
          document.getElementsByTagName('html')[0].classList.toggle(_this2.config.setRootClass);
        }

        _this2.setAttributes(_this2.buttonObj, {
          'aria-expanded': !expanded,
          'aria-label': expanded ? _this2.labelOpen : _this2.labelClose
        });

        if (_this2.config.switchButtonHtml !== false) {
          _this2.buttonObj.innerHTML = expanded ? '<span>' + _this2.textOpen + '</span>' : '<span>' + _this2.textClose + '</span>';
        }

        for (var i = 0; i < _this2.targetObj.length; i++) {
          _this2.targetObj[i].setAttribute('aria-hidden', expanded);
        }
      });

      if (expanded) {
        this.buttonObj.focus();
      } else {
        if (this.config.setFocusToElement !== false) {
          var element = this.targetObj[0].querySelector(this.config.setFocusToElement);

          if (element.length !== null) {
            setTimeout(function () {
              element.focus();
            }, 100);
            return;
          }
        }

        if (this.config.setFocusToFirstElement === true) {
          setTimeout(function () {
            (_this2.targetObj[0].querySelector('a,input,button') || _this2.targetObj[0]).focus();
          }, 100);
        }
      }
    }
  }, {
    key: "isInViewport",
    value: function isInViewport(element) {
      var rect = element.getBoundingClientRect();
      return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
    }
  }, {
    key: "resetScrollPosition",
    value: function resetScrollPosition() {
      if (!this.isInViewport(this.buttonObj)) {
        window.scroll({
          top: this.scrollPosition,
          behavior: 'smooth'
        });
      }
    }
  }, {
    key: "disableFocusHandling",
    value: function disableFocusHandling(status) {
      this.config.disableFocusHandling = status;
    }
  }, {
    key: "addAria",
    value: function addAria() {
      var controls = [];

      for (var i = 0; i < this.targetObj.length; i++) {
        this.setAttributes(this.targetObj[i], {
          'aria-hidden': true
        });
        controls.push(this.targetObj[i].id);
      }

      if (this.buttonObj.nodeName != 'BUTTON') {
        this.buttonObj.setAttribute('role', 'button');
      }

      this.setAttributes(this.buttonObj, {
        'aria-controls': controls.join(' '),
        'aria-expanded': 'false',
        'aria-label': this.labelOpen
      });
    }
  }]);

  return pxEasyExpand;
}();

var _default = pxEasyExpand;
exports.default = _default;

},{}],4:[function(require,module,exports){
"use strict"; // --------------------------------------
// responsive Hintergrund-Bilder

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var pxResponsiveBackgroundImage =
/*#__PURE__*/
function () {
  function pxResponsiveBackgroundImage(responsiveBackgroundContainer) {
    _classCallCheck(this, pxResponsiveBackgroundImage);

    // Array alle Container
    this.responsiveBackgroundContainer = responsiveBackgroundContainer; // auf gehts

    for (var i = 0; i < responsiveBackgroundContainer.length; i++) {
      this.addImageAsBackground(responsiveBackgroundContainer[i]);
    }
  }

  _createClass(pxResponsiveBackgroundImage, [{
    key: "addImageAsBackground",
    value: function addImageAsBackground(container) {
      var image = container.querySelector('img');

      image.onload = function () {
        if (image.currentSrc) {
          container.style.backgroundImage = 'url("' + image.currentSrc + '")';
        } else if (image.src) {
          container.style.backgroundImage = 'url("' + image.src + '")';
        }
      };

      if (image.complete) {
        if (image.currentSrc) {
          container.style.backgroundImage = 'url("' + image.currentSrc + '")';
        } else if (image.src) {
          container.style.backgroundImage = 'url("' + image.src + '")';
        }
      }
    }
  }]);

  return pxResponsiveBackgroundImage;
}();

var _default = pxResponsiveBackgroundImage;
exports.default = _default;

},{}],5:[function(require,module,exports){
"use strict";

// --------------------------------------
// Toplink
ready(function () {
  // fade an element from the current state to full opacity in "duration" ms
  // function fadeOut(el, duration) {
  //     var s = el.style, step = 25/(duration || 300);
  //     s.opacity = s.opacity || 1;
  //     (function fade() { (s.opacity -= step) < 0 ? s.display = "none" : setTimeout(fade, 25); })();
  // }
  // fade out an element from the current state to full transparency in "duration" ms
  // display is the display style the element is assigned after the animation is done
  // function fadeIn(el, duration, display) {
  //     var s = el.style, step = 25/(duration || 300);
  //     s.opacity = s.opacity || 0;
  //     s.display = display || "block";
  //     (function fade() { (s.opacity = parseFloat(s.opacity)+step) > 1 ? s.opacity = 1 : setTimeout(fade, 25); })();
  // }
  var toplink = document.querySelectorAll('.toplink')[0];
  window.addEventListener('scroll', function () {
    if (Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) > 100) {
      // fadeIn(toplink,400,'block');
      toplink.style.display = 'block';
    } else {
      // fadeOut(toplink,400);
      toplink.style.display = 'none';
    }
  });

  if (Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) < 101) {
    toplink.style.display = 'none';
  }
});

},{}],6:[function(require,module,exports){
"use strict";

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
if (typeof Object.assign != 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) {
      // .length of function is 2
      'use strict';

      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) {
          // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }

      return to;
    },
    writable: true,
    configurable: true
  });
}

},{}],7:[function(require,module,exports){
"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

void function (root, factory) {
  if (typeof define === 'function' && define.amd) define(factory);else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') module.exports = factory();else factory();
}(void 0, function () {
  var DETAILS = 'details';
  var SUMMARY = 'summary';
  var supported = checkSupport();
  if (supported) return; // Add a classname

  document.documentElement.className += ' no-details';
  window.addEventListener('click', clickHandler);
  injectStyle('details-polyfill-style', 'html.no-details ' + DETAILS + ':not([open]) > :not(' + SUMMARY + ') { display: none; }\n' + 'html.no-details ' + DETAILS + ' > ' + SUMMARY + ":before { content: \"\u25B6\"; display: inline-block; font-size: .8em; width: 1.5em; }\n" + 'html.no-details ' + DETAILS + '[open] > ' + SUMMARY + ":before { content: \"\u25BC\"; }");
  /*
   * Click handler for `<summary>` tags
   */

  function clickHandler(e) {
    if (e.target.nodeName.toLowerCase() === 'summary') {
      var details = e.target.parentNode;
      if (!details) return;

      if (details.getAttribute('open')) {
        details.open = false;
        details.removeAttribute('open');
      } else {
        details.open = true;
        details.setAttribute('open', 'open');
      }
    }
  }
  /*
   * Checks for support for `<details>`
   */


  function checkSupport() {
    var el = document.createElement(DETAILS);
    if (!('open' in el)) return false;
    el.innerHTML = '<' + SUMMARY + '>a</' + SUMMARY + '>b';
    document.body.appendChild(el);
    var diff = el.offsetHeight;
    el.open = true;
    var result = diff != el.offsetHeight;
    document.body.removeChild(el);
    return result;
  }
  /*
   * Injects styles (idempotent)
   */


  function injectStyle(id, style) {
    if (document.getElementById(id)) return;
    var el = document.createElement('style');
    el.id = id;
    el.innerHTML = style;
    document.getElementsByTagName('head')[0].appendChild(el);
  }
}); // eslint-disable-line semi

},{}],8:[function(require,module,exports){
"use strict";

// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
if (!Array.prototype.findIndex) {
  Object.defineProperty(Array.prototype, 'findIndex', {
    value: function value(predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this); // 2. Let len be ? ToLength(? Get(O, "length")).

      var len = o.length >>> 0; // 3. If IsCallable(predicate) is false, throw a TypeError exception.

      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      } // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.


      var thisArg = arguments[1]; // 5. Let k be 0.

      var k = 0; // 6. Repeat, while k < len

      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return k.
        var kValue = o[k];

        if (predicate.call(thisArg, kValue, k, o)) {
          return k;
        } // e. Increase k by 1.


        k++;
      } // 7. Return -1.


      return -1;
    },
    configurable: true,
    writable: true
  });
}

},{}],9:[function(require,module,exports){
(function(window, factory) {
	var lazySizes = factory(window, window.document, Date);
	window.lazySizes = lazySizes;
	if(typeof module == 'object' && module.exports){
		module.exports = lazySizes;
	}
}(typeof window != 'undefined' ?
      window : {}, function l(window, document, Date) { // Pass in the windoe Date function also for SSR because the Date class can be lost
	'use strict';
	/*jshint eqnull:true */

	var lazysizes, lazySizesCfg;

	(function(){
		var prop;

		var lazySizesDefaults = {
			lazyClass: 'lazyload',
			loadedClass: 'lazyloaded',
			loadingClass: 'lazyloading',
			preloadClass: 'lazypreload',
			errorClass: 'lazyerror',
			//strictClass: 'lazystrict',
			autosizesClass: 'lazyautosizes',
			srcAttr: 'data-src',
			srcsetAttr: 'data-srcset',
			sizesAttr: 'data-sizes',
			//preloadAfterLoad: false,
			minSize: 40,
			customMedia: {},
			init: true,
			expFactor: 1.5,
			hFac: 0.8,
			loadMode: 2,
			loadHidden: true,
			ricTimeout: 0,
			throttleDelay: 125,
		};

		lazySizesCfg = window.lazySizesConfig || window.lazysizesConfig || {};

		for(prop in lazySizesDefaults){
			if(!(prop in lazySizesCfg)){
				lazySizesCfg[prop] = lazySizesDefaults[prop];
			}
		}
	})();

	if (!document || !document.getElementsByClassName) {
		return {
			init: function () {},
			cfg: lazySizesCfg,
			noSupport: true,
		};
	}

	var docElem = document.documentElement;

	var supportPicture = window.HTMLPictureElement;

	var _addEventListener = 'addEventListener';

	var _getAttribute = 'getAttribute';

	/**
	 * Update to bind to window because 'this' becomes null during SSR
	 * builds.
	 */
	var addEventListener = window[_addEventListener].bind(window);

	var setTimeout = window.setTimeout;

	var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

	var requestIdleCallback = window.requestIdleCallback;

	var regPicture = /^picture$/i;

	var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

	var regClassCache = {};

	var forEach = Array.prototype.forEach;

	var hasClass = function(ele, cls) {
		if(!regClassCache[cls]){
			regClassCache[cls] = new RegExp('(\\s|^)'+cls+'(\\s|$)');
		}
		return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
	};

	var addClass = function(ele, cls) {
		if (!hasClass(ele, cls)){
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
		}
	};

	var removeClass = function(ele, cls) {
		var reg;
		if ((reg = hasClass(ele,cls))) {
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
		}
	};

	var addRemoveLoadEvents = function(dom, fn, add){
		var action = add ? _addEventListener : 'removeEventListener';
		if(add){
			addRemoveLoadEvents(dom, fn);
		}
		loadEvents.forEach(function(evt){
			dom[action](evt, fn);
		});
	};

	var triggerEvent = function(elem, name, detail, noBubbles, noCancelable){
		var event = document.createEvent('Event');

		if(!detail){
			detail = {};
		}

		detail.instance = lazysizes;

		event.initEvent(name, !noBubbles, !noCancelable);

		event.detail = detail;

		elem.dispatchEvent(event);
		return event;
	};

	var updatePolyfill = function (el, full){
		var polyfill;
		if( !supportPicture && ( polyfill = (window.picturefill || lazySizesCfg.pf) ) ){
			if(full && full.src && !el[_getAttribute]('srcset')){
				el.setAttribute('srcset', full.src);
			}
			polyfill({reevaluate: true, elements: [el]});
		} else if(full && full.src){
			el.src = full.src;
		}
	};

	var getCSS = function (elem, style){
		return (getComputedStyle(elem, null) || {})[style];
	};

	var getWidth = function(elem, parent, width){
		width = width || elem.offsetWidth;

		while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
			width =  parent.offsetWidth;
			parent = parent.parentNode;
		}

		return width;
	};

	var rAF = (function(){
		var running, waiting;
		var firstFns = [];
		var secondFns = [];
		var fns = firstFns;

		var run = function(){
			var runFns = fns;

			fns = firstFns.length ? secondFns : firstFns;

			running = true;
			waiting = false;

			while(runFns.length){
				runFns.shift()();
			}

			running = false;
		};

		var rafBatch = function(fn, queue){
			if(running && !queue){
				fn.apply(this, arguments);
			} else {
				fns.push(fn);

				if(!waiting){
					waiting = true;
					(document.hidden ? setTimeout : requestAnimationFrame)(run);
				}
			}
		};

		rafBatch._lsFlush = run;

		return rafBatch;
	})();

	var rAFIt = function(fn, simple){
		return simple ?
			function() {
				rAF(fn);
			} :
			function(){
				var that = this;
				var args = arguments;
				rAF(function(){
					fn.apply(that, args);
				});
			}
		;
	};

	var throttle = function(fn){
		var running;
		var lastTime = 0;
		var gDelay = lazySizesCfg.throttleDelay;
		var rICTimeout = lazySizesCfg.ricTimeout;
		var run = function(){
			running = false;
			lastTime = Date.now();
			fn();
		};
		var idleCallback = requestIdleCallback && rICTimeout > 49 ?
			function(){
				requestIdleCallback(run, {timeout: rICTimeout});

				if(rICTimeout !== lazySizesCfg.ricTimeout){
					rICTimeout = lazySizesCfg.ricTimeout;
				}
			} :
			rAFIt(function(){
				setTimeout(run);
			}, true)
		;

		return function(isPriority){
			var delay;

			if((isPriority = isPriority === true)){
				rICTimeout = 33;
			}

			if(running){
				return;
			}

			running =  true;

			delay = gDelay - (Date.now() - lastTime);

			if(delay < 0){
				delay = 0;
			}

			if(isPriority || delay < 9){
				idleCallback();
			} else {
				setTimeout(idleCallback, delay);
			}
		};
	};

	//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
	var debounce = function(func) {
		var timeout, timestamp;
		var wait = 99;
		var run = function(){
			timeout = null;
			func();
		};
		var later = function() {
			var last = Date.now() - timestamp;

			if (last < wait) {
				setTimeout(later, wait - last);
			} else {
				(requestIdleCallback || run)(run);
			}
		};

		return function() {
			timestamp = Date.now();

			if (!timeout) {
				timeout = setTimeout(later, wait);
			}
		};
	};

	var loader = (function(){
		var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

		var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;

		var regImg = /^img$/i;
		var regIframe = /^iframe$/i;

		var supportScroll = ('onscroll' in window) && !(/(gle|ing)bot/.test(navigator.userAgent));

		var shrinkExpand = 0;
		var currentExpand = 0;

		var isLoading = 0;
		var lowRuns = -1;

		var resetPreloading = function(e){
			isLoading--;
			if(!e || isLoading < 0 || !e.target){
				isLoading = 0;
			}
		};

		var isVisible = function (elem) {
			if (isBodyHidden == null) {
				isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
			}

			return isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');
		};

		var isNestedVisible = function(elem, elemExpand){
			var outerRect;
			var parent = elem;
			var visible = isVisible(elem);

			eLtop -= elemExpand;
			eLbottom += elemExpand;
			eLleft -= elemExpand;
			eLright += elemExpand;

			while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
				visible = ((getCSS(parent, 'opacity') || 1) > 0);

				if(visible && getCSS(parent, 'overflow') != 'visible'){
					outerRect = parent.getBoundingClientRect();
					visible = eLright > outerRect.left &&
						eLleft < outerRect.right &&
						eLbottom > outerRect.top - 1 &&
						eLtop < outerRect.bottom + 1
					;
				}
			}

			return visible;
		};

		var checkElements = function() {
			var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal,
				beforeExpandVal, defaultExpand, preloadExpand, hFac;
			var lazyloadElems = lazysizes.elements;

			if((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){

				i = 0;

				lowRuns++;

				for(; i < eLlen; i++){

					if(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}

					if(!supportScroll || (lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i]))){unveilElement(lazyloadElems[i]);continue;}

					if(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){
						elemExpand = currentExpand;
					}

					if (!defaultExpand) {
						defaultExpand = (!lazySizesCfg.expand || lazySizesCfg.expand < 1) ?
							docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 :
							lazySizesCfg.expand;

						lazysizes._defEx = defaultExpand;

						preloadExpand = defaultExpand * lazySizesCfg.expFactor;
						hFac = lazySizesCfg.hFac;
						isBodyHidden = null;

						if(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){
							currentExpand = preloadExpand;
							lowRuns = 0;
						} else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){
							currentExpand = defaultExpand;
						} else {
							currentExpand = shrinkExpand;
						}
					}

					if(beforeExpandVal !== elemExpand){
						eLvW = innerWidth + (elemExpand * hFac);
						elvH = innerHeight + elemExpand;
						elemNegativeExpand = elemExpand * -1;
						beforeExpandVal = elemExpand;
					}

					rect = lazyloadElems[i].getBoundingClientRect();

					if ((eLbottom = rect.bottom) >= elemNegativeExpand &&
						(eLtop = rect.top) <= elvH &&
						(eLright = rect.right) >= elemNegativeExpand * hFac &&
						(eLleft = rect.left) <= eLvW &&
						(eLbottom || eLright || eLleft || eLtop) &&
						(lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) &&
						((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){
						unveilElement(lazyloadElems[i]);
						loadedSomething = true;
						if(isLoading > 9){break;}
					} else if(!loadedSomething && isCompleted && !autoLoadElem &&
						isLoading < 4 && lowRuns < 4 && loadMode > 2 &&
						(preloadElems[0] || lazySizesCfg.preloadAfterLoad) &&
						(preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != 'auto')))){
						autoLoadElem = preloadElems[0] || lazyloadElems[i];
					}
				}

				if(autoLoadElem && !loadedSomething){
					unveilElement(autoLoadElem);
				}
			}
		};

		var throttledCheckElements = throttle(checkElements);

		var switchLoadingClass = function(e){
			var elem = e.target;

			if (elem._lazyCache) {
				delete elem._lazyCache;
				return;
			}

			resetPreloading(e);
			addClass(elem, lazySizesCfg.loadedClass);
			removeClass(elem, lazySizesCfg.loadingClass);
			addRemoveLoadEvents(elem, rafSwitchLoadingClass);
			triggerEvent(elem, 'lazyloaded');
		};
		var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
		var rafSwitchLoadingClass = function(e){
			rafedSwitchLoadingClass({target: e.target});
		};

		var changeIframeSrc = function(elem, src){
			try {
				elem.contentWindow.location.replace(src);
			} catch(e){
				elem.src = src;
			}
		};

		var handleSources = function(source){
			var customMedia;

			var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);

			if( (customMedia = lazySizesCfg.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){
				source.setAttribute('media', customMedia);
			}

			if(sourceSrcset){
				source.setAttribute('srcset', sourceSrcset);
			}
		};

		var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){
			var src, srcset, parent, isPicture, event, firesLoad;

			if(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){

				if(sizes){
					if(isAuto){
						addClass(elem, lazySizesCfg.autosizesClass);
					} else {
						elem.setAttribute('sizes', sizes);
					}
				}

				srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
				src = elem[_getAttribute](lazySizesCfg.srcAttr);

				if(isImg) {
					parent = elem.parentNode;
					isPicture = parent && regPicture.test(parent.nodeName || '');
				}

				firesLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));

				event = {target: elem};

				addClass(elem, lazySizesCfg.loadingClass);

				if(firesLoad){
					clearTimeout(resetPreloadingTimer);
					resetPreloadingTimer = setTimeout(resetPreloading, 2500);
					addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
				}

				if(isPicture){
					forEach.call(parent.getElementsByTagName('source'), handleSources);
				}

				if(srcset){
					elem.setAttribute('srcset', srcset);
				} else if(src && !isPicture){
					if(regIframe.test(elem.nodeName)){
						changeIframeSrc(elem, src);
					} else {
						elem.src = src;
					}
				}

				if(isImg && (srcset || isPicture)){
					updatePolyfill(elem, {src: src});
				}
			}

			if(elem._lazyRace){
				delete elem._lazyRace;
			}
			removeClass(elem, lazySizesCfg.lazyClass);

			rAF(function(){
				// Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
				var isLoaded = elem.complete && elem.naturalWidth > 1;

				if( !firesLoad || isLoaded){
					if (isLoaded) {
						addClass(elem, 'ls-is-cached');
					}
					switchLoadingClass(event);
					elem._lazyCache = true;
					setTimeout(function(){
						if ('_lazyCache' in elem) {
							delete elem._lazyCache;
						}
					}, 9);
				}
				if (elem.loading == 'lazy') {
					isLoading--;
				}
			}, true);
		});

		var unveilElement = function (elem){
			if (elem._lazyRace) {return;}
			var detail;

			var isImg = regImg.test(elem.nodeName);

			//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
			var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]('sizes'));
			var isAuto = sizes == 'auto';

			if( (isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)){return;}

			detail = triggerEvent(elem, 'lazyunveilread').detail;

			if(isAuto){
				 autoSizer.updateElem(elem, true, elem.offsetWidth);
			}

			elem._lazyRace = true;
			isLoading++;

			lazyUnveil(elem, detail, isAuto, sizes, isImg);
		};

		var afterScroll = debounce(function(){
			lazySizesCfg.loadMode = 3;
			throttledCheckElements();
		});

		var altLoadmodeScrollListner = function(){
			if(lazySizesCfg.loadMode == 3){
				lazySizesCfg.loadMode = 2;
			}
			afterScroll();
		};

		var onload = function(){
			if(isCompleted){return;}
			if(Date.now() - started < 999){
				setTimeout(onload, 999);
				return;
			}


			isCompleted = true;

			lazySizesCfg.loadMode = 3;

			throttledCheckElements();

			addEventListener('scroll', altLoadmodeScrollListner, true);
		};

		return {
			_: function(){
				started = Date.now();

				lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
				preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + ' ' + lazySizesCfg.preloadClass);

				addEventListener('scroll', throttledCheckElements, true);

				addEventListener('resize', throttledCheckElements, true);

				addEventListener('pageshow', function (e) {
					if (e.persisted) {
						var loadingElements = document.querySelectorAll('.' + lazySizesCfg.loadingClass);

						if (loadingElements.length && loadingElements.forEach) {
							requestAnimationFrame(function () {
								loadingElements.forEach( function (img) {
									if (img.complete) {
										unveilElement(img);
									}
								});
							});
						}
					}
				});

				if(window.MutationObserver){
					new MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );
				} else {
					docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
					docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
					setInterval(throttledCheckElements, 999);
				}

				addEventListener('hashchange', throttledCheckElements, true);

				//, 'fullscreenchange'
				['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend'].forEach(function(name){
					document[_addEventListener](name, throttledCheckElements, true);
				});

				if((/d$|^c/.test(document.readyState))){
					onload();
				} else {
					addEventListener('load', onload);
					document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
					setTimeout(onload, 20000);
				}

				if(lazysizes.elements.length){
					checkElements();
					rAF._lsFlush();
				} else {
					throttledCheckElements();
				}
			},
			checkElems: throttledCheckElements,
			unveil: unveilElement,
			_aLSL: altLoadmodeScrollListner,
		};
	})();


	var autoSizer = (function(){
		var autosizesElems;

		var sizeElement = rAFIt(function(elem, parent, event, width){
			var sources, i, len;
			elem._lazysizesWidth = width;
			width += 'px';

			elem.setAttribute('sizes', width);

			if(regPicture.test(parent.nodeName || '')){
				sources = parent.getElementsByTagName('source');
				for(i = 0, len = sources.length; i < len; i++){
					sources[i].setAttribute('sizes', width);
				}
			}

			if(!event.detail.dataAttr){
				updatePolyfill(elem, event.detail);
			}
		});
		var getSizeElement = function (elem, dataAttr, width){
			var event;
			var parent = elem.parentNode;

			if(parent){
				width = getWidth(elem, parent, width);
				event = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});

				if(!event.defaultPrevented){
					width = event.detail.width;

					if(width && width !== elem._lazysizesWidth){
						sizeElement(elem, parent, event, width);
					}
				}
			}
		};

		var updateElementsSizes = function(){
			var i;
			var len = autosizesElems.length;
			if(len){
				i = 0;

				for(; i < len; i++){
					getSizeElement(autosizesElems[i]);
				}
			}
		};

		var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

		return {
			_: function(){
				autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
				addEventListener('resize', debouncedUpdateElementsSizes);
			},
			checkElems: debouncedUpdateElementsSizes,
			updateElem: getSizeElement
		};
	})();

	var init = function(){
		if(!init.i && document.getElementsByClassName){
			init.i = true;
			autoSizer._();
			loader._();
		}
	};

	setTimeout(function(){
		if(lazySizesCfg.init){
			init();
		}
	});

	lazysizes = {
		cfg: lazySizesCfg,
		autoSizer: autoSizer,
		loader: loader,
		init: init,
		uP: updatePolyfill,
		aC: addClass,
		rC: removeClass,
		hC: hasClass,
		fire: triggerEvent,
		gW: getWidth,
		rAF: rAF,
	};

	return lazysizes;
}
));

},{}],10:[function(require,module,exports){
(function(window, factory) {
	var globalInstall = function(){
		factory(window.lazySizes);
		window.removeEventListener('lazyunveilread', globalInstall, true);
	};

	factory = factory.bind(null, window, window.document);

	if(typeof module == 'object' && module.exports){
		factory(require('lazysizes'));
	} else if(window.lazySizes) {
		globalInstall();
	} else {
		window.addEventListener('lazyunveilread', globalInstall, true);
	}
}(window, function(window, document, lazySizes) {
	'use strict';

	var imgSupport = 'loading' in HTMLImageElement.prototype;
	var iframeSupport = 'loading' in HTMLIFrameElement.prototype;
	var isConfigSet = false;
	var oldPrematureUnveil = lazySizes.prematureUnveil;
	var cfg = lazySizes.cfg;
	var listenerMap = {
		focus: 1,
		mouseover: 1,
		click: 1,
		load: 1,
		transitionend: 1,
		animationend: 1,
		scroll: 1,
		resize: 1,
	};

	if (!cfg.nativeLoading) {
		cfg.nativeLoading = {};
	}

	if (!window.addEventListener || !window.MutationObserver || (!imgSupport && !iframeSupport)) {
		return;
	}

	function disableEvents() {
		var loader = lazySizes.loader;
		var throttledCheckElements = loader.checkElems;
		var removeALSL = function(){
			setTimeout(function(){
				window.removeEventListener('scroll', loader._aLSL, true);
			}, 1000);
		};
		var currentListenerMap = typeof cfg.nativeLoading.disableListeners == 'object' ?
			cfg.nativeLoading.disableListeners :
			listenerMap;

		if (currentListenerMap.scroll) {
			window.addEventListener('load', removeALSL);
			removeALSL();

			window.removeEventListener('scroll', throttledCheckElements, true);
		}

		if (currentListenerMap.resize) {
			window.removeEventListener('resize', throttledCheckElements, true);
		}

		Object.keys(currentListenerMap).forEach(function(name) {
			if (currentListenerMap[name]) {
				document.removeEventListener(name, throttledCheckElements, true);
			}
		});
	}

	function runConfig() {
		if (isConfigSet) {return;}
		isConfigSet = true;

		if (imgSupport && iframeSupport && cfg.nativeLoading.disableListeners) {
			if (cfg.nativeLoading.disableListeners === true) {
				cfg.nativeLoading.setLoadingAttribute = true;
			}

			disableEvents();
		}

		if (cfg.nativeLoading.setLoadingAttribute) {
			window.addEventListener('lazybeforeunveil', function(e){
				var element = e.target;

				if ('loading' in element && !element.getAttribute('loading')) {
					element.setAttribute('loading', 'lazy');
				}
			}, true);
		}
	}

	lazySizes.prematureUnveil = function prematureUnveil(element) {

		if (!isConfigSet) {
			runConfig();
		}

		if ('loading' in element &&
			(cfg.nativeLoading.setLoadingAttribute || element.getAttribute('loading')) &&
			(element.getAttribute('data-sizes') != 'auto' || element.offsetWidth)) {
			return true;
		}

		if (oldPrematureUnveil) {
			return oldPrematureUnveil(element);
		}
	};

}));

},{"lazysizes":9}]},{},[1]);
